export default __webpack_public_path__ + "static/media/724.9b06181c.png";